import { Routes } from '@angular/router';
import { ProductLookupComponent } from './product-lookup.component';

export const routes: Routes = [
  {
    path: '',
    component: ProductLookupComponent,
  },
];
